import React from 'react';
import startsWith from 'lodash/startsWith';
import formatter from 'app/shared/utils/formatter';
import { itemMatchCX } from './styles';

type Item = {
  areaType?: string;
  type?: string;
  [key: string]: unknown;
};

type SortedArea = {
  areaType: string;
  itemList: Array<Item>;
};

const controller = {
  getSortedItems(items: Array<Item> = []): Array<SortedArea> {
    const sortType = items[0]?.areaType ? 'areaType' : 'type';
    const sortedItems: Record<string, Array<Item>> = {};
    const sortedAreaTypes: Array<string> = [];

    items.forEach((item) => {
      const key = item[sortType] as string;
      if (!sortedItems[key]) {
        sortedItems[key] = [item];
        sortedAreaTypes.push(key);
      } else {
        sortedItems[key].push(item);
      }
    });

    return sortedAreaTypes.map((areaType) => {
      return {
        areaType,
        itemList: sortedItems[areaType],
      };
    });
  },

  getAreaTypeDisplayName(type: string): string | undefined {
    const DISPLAY_NAMES: Record<string, string> = {
      Borough: 'Boroughs',
      City: 'Cities',
      Neighborhood: 'Neighborhoods',
      School: 'Schools',
      Property: 'Properties',
      Zip: 'Zipcodes',
      savedSearch: 'Saved search alerts',
    };

    return DISPLAY_NAMES[type];
  },

  getStyledNameFromMatch(name = '', match = ''): JSX.Element {
    if (!match) {
      return <span>{name}</span>;
    }
    const nameArr = name.split(' ');
    const matchCap = formatter.string.firstCaps(formatter.string.removePunctuation(match));
    const matchArr = matchCap.split(' ').sort((a: string, b: string) => b.length - a.length);
    const result: Array<JSX.Element> = [];
    let remainder: string;
    let m = 0;
    let matchSubstr: string;
    let didInsert = false;

    nameArr.forEach((nameSubstr, index) => {
      while (m < matchArr.length) {
        // check if an area name is not capitalized
        matchSubstr = nameSubstr === nameSubstr.toLowerCase() ? matchArr[m].toLowerCase() : matchArr[m];
        if (startsWith(nameSubstr, matchSubstr)) {
          result.push(
            <span className={itemMatchCX} data-name="itemMatchCX" key={`${matchSubstr}-${m}-${index}`}>
              {matchSubstr}
            </span>,
          );
          remainder = nameSubstr.replace(matchSubstr, '');
          if (remainder) {
            result.push(<span key={`${remainder}-${m}-${index}`}>{remainder}</span>);
          }

          didInsert = true;
          matchArr.splice(m, 1);
          break;
        } else {
          m++;
        }
      }
      if (didInsert) {
        result.push(<span key={`space-${index}`}> </span>);
        didInsert = false;
      } else {
        result.push(<span key={`no-match-${index}`}>{`${nameSubstr} `}</span>);
      }
      m = 0;
    });

    return <>{result}</>;
  },
};

export default controller;
